/**
 * ToDo API
 * An ASP.NET Core Web API for managing ToDo items
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MyUpcomingEventsRequestModel { 
    userIds?: Array<string>;
    startTime?: string;
    endTime?: string;
    timeZoneId?: string;
    optimize?: boolean;
    forceTimeFrameReOptimize?: boolean;
    doNotReturnOptimized?: boolean;
    addressId?: string;
}

